import { AnyAction } from 'redux';

interface Location {
    location: [];
    loading: boolean;
}

const initialState: Location = {
    location: [],
    loading: false,
};

export const GetLocations = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'GET_LOCATIONS':
            return {
                ...state,
                location: action.payload,
            };
        case 'LOADING_LOCATIONS':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
